import React from 'react';

import { Props } from './FlexibleContent.types';

const FlexibleContent = ({ content, className }: Props) => {
  if (React.isValidElement(content)) {
    return content;
  }

  return <span className={className}>{content}</span>;
};

export default FlexibleContent;
